export default __webpack_public_path__ + "static/media/avatar_ali5.c83812a1.mp3";